import { render, staticRenderFns } from "./station_main_plc.vue?vue&type=template&id=13c06b08&scoped=true"
import script from "./station_main_plc.vue?vue&type=script&lang=js"
export * from "./station_main_plc.vue?vue&type=script&lang=js"
import style0 from "./station_main_plc.vue?vue&type=style&index=0&id=13c06b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c06b08",
  null
  
)

export default component.exports